import { runSaga } from "../../middleware/sagasMiddleware";
import React from "react";
export const connectSaga = (WrappedComponent, saga) => {
  return class extends React.Component {
    componentWillMount() {
      if (saga) {
        this.saga = runSaga(saga);
      }
    }

    componentWillUnmount() {
      if (this.saga) {
        this.saga.cancel();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};



// WEBPACK FOOTER //
// ./src/util/hoc/connectSaga.js